import emailjs from '@emailjs/browser';

export const emailService = {
    /**
     * Send an invoice email using EmailJS
     * @param {Object} invoice - The invoice object
     * @param {Object} client - The client object
     * @param {Object} settings - Business settings (contains keys and business info)
     * @param {String} link - Public portal link
     * @returns {Promise}
     */
    async sendInvoiceEmail(invoice, client, settings, link) {
        const { emailServiceId, emailTemplateId, emailPublicKey } = settings;

        if (!emailServiceId || !emailTemplateId || !emailPublicKey) {
            throw new Error('Email configuration missing. Please check your settings.');
        }

        try {
            const templateParams = {
                to_email: client.email,
                to_name: client.name,
                from_name: settings.businessName,
                invoice_number: invoice.invoiceNumber,
                amount: settings.currency + ' ' + invoice.total.toFixed(2),
                link: link,
                due_date: new Date(invoice.dueDate).toLocaleDateString(),
            };

            const response = await emailjs.send(
                emailServiceId,
                emailTemplateId,
                templateParams,
                emailPublicKey
            );

            return response;
        } catch (error) {
            console.error('EmailJS Error:', error);
            throw error;
        }
    }
};
